<!DOCTYPE html>
<template>
<b-navbar class="header"
          :class="{'scrolled': isScrolled}"
          @scroll="onScroll"
          sticky>


  <b-container class="wrapper">
    <div class="brand large"
         @click="goHome">
      <div class="logo" />
      BlueTeam
    </div>



    <div class="userInfo">


      <template v-if="userData">
        <b-button class="user"
                  size="sm"
                  variant="outline-primary"
                  @click="signOut">
          Sign out
        </b-button>
      </template>

      <template v-else>
        <b-button class="user"
                  variant="success"
                  size="sm"
                  @click="getStarted">
          Get started
        </b-button>
        <b-button class="user"
                  size="sm"
                  variant="outline-primary"
                  @click="signIn">
          Sign in
        </b-button>
      </template>

    </div>
  </b-container>
</b-navbar>
</template>

<script>
const firebase = require( '../firebaseConfig.js' )
const users = firebase.db.collection( 'users' )
export default {
  name: 'Header',
  props: {
    user: Object,
  },
  data() {
    return {
      userData: null,
      isScrolled: false,
      items: [ {
          text: 'Home',
          href: '#'
        },
        {
          text: 'Hire a professional',
          href: '#'
        },
        {
          text: 'Get hired',
          active: true
        }
      ]
    }
  },
  mounted() {
    window.addEventListener( 'scroll', this.onScroll )
  },
  beforeDestroy() {
    window.removeEventListener( 'scroll', this.onScroll )
  },
  watch: {
    user: {
      immediate: true,
      handler( user ) {
        if ( user ) {
          this.$bind( 'userData', users.doc( user.uid ) )
        } else {
          this.userData = null
        }
      },
    },
  },
  computed: {},
  methods: {
    goHome() {
      if ( this.userData ) {
        this.$router.push( '/dashboard' ).catch( () => {} )
      } else {
        this.$router.push( '/' ).catch( () => {} )
      }
    },
    signIn() {
      this.$root.next = this.$router.history.current.path
      this.$router.push( '/signin' ).catch( () => {} )
    },
    signOut() {
      firebase.firebase.auth().signOut()
        .then( () => {
          this.$router.push( "/" ).catch( () => {} )
        } )
        //.catch( function( err ) {
          // Handle errors
          //console.log( err )
        //} )
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      // Because of momentum scrolling on mobiles,
      // we shouldn't continue if it is less than zero
      if ( currentScrollPosition < 0 ) {
        return
      }
      // Here we determine whether we need to show or hide the navbar
      this.isScrolled = currentScrollPosition > 0
    },
    getStarted() {
      if ( this.$router.history.current.path == '/home' ) {
        window.location.hash = ''
        window.location.hash = 'onboarding'
      } else {
        this.$router.push( '/home#onboarding' ).catch( () => {} )
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/styles/overrides.scss";
.header {
    width: 100%;
    background: white;

    &.scrolled {
        box-shadow: 0 0 2rem rgba(0,0,0,0.3);

        .brand {
            transform: scale(0.8);
        }
    }

    .wrapper {
        margin: auto;
        width: 100%;
        padding: 1rem;
        color: $primary;
        display: grid;
        grid-template-columns: auto auto;
        justify-content: space-between;

        .userInfo {
            display: grid;
            grid-auto-flow: column;
            grid-column-gap: 1rem;
        }
    }
}
</style>
